import { ticketLangTypeSchema, yesNoSchema } from '@server/schemas'

import type { RawGetSubscribeMappList, SubscribeMappListDto, TicketInfo } from '../model'
import { EXTEND_ACTIVE_SUBSCRIBE_STATUSES } from '../model/constants'

export const hasExtendInActiveSubscription = (list: SubscribeMappListDto[] | undefined): boolean =>
  list?.some(
    (item) => item.subscribeType === 'EXTEND' && EXTEND_ACTIVE_SUBSCRIBE_STATUSES.includes(item.subscribeStatus),
  ) ?? false

export const filterActiveTicket = (ticket: RawGetSubscribeMappList) => ticket.remain_count > 0
export const filterTrialTicket = (ticket: RawGetSubscribeMappList) => ticket.is_trial_ticket === 'Y'
/** 국가와 무관하게 BASIC 정규 수강권을 고른다. 언어 허용 범위는 응답 스키마에서 검증한다. */
export const filterRegularTicket = (ticket: RawGetSubscribeMappList) =>
  ticket.is_trial_ticket !== 'Y' &&
  ticket.curriculum_type === 'BASIC' &&
  ticketLangTypeSchema.safeParse(ticket.lang_type).success &&
  ticketLangTypeSchema.safeParse(ticket.payment_lang_type).success

export const transformTicketInfo = <T extends RawGetSubscribeMappList>(
  ticket: T,
): TicketInfo & { lang_type: T['lang_type'] } => ({
  subscribe_mapp_id: ticket.subscribe_mapp_id,
  curriculum_type: ticket.curriculum_type,
  lang_type: ticket.lang_type,
  lesson_time: ticket.lesson_time,
  is_trial_ticket: ticket.is_trial_ticket,
  remain_count: ticket.remain_count,
  ticket_expire_date: ticket.ticket_expire_date,
  ticket_start_date: ticket.ticket_start_date,
  ticket_start_datetime: ticket.ticket_start_datetime,
  ticket_expire_datetime: ticket.ticket_expire_datetime,
  origin_count: ticket.origin_count,
  reg_class_count: ticket.reg_class_count,
})

export const isUnlimitedTicket = (ticket: TicketInfo) => {
  return (
    ticket.unlimit_yn === yesNoSchema.enum.Y ||
    ticket.remain_count === 999 ||
    ticket.origin_count === '999' ||
    ticket.origin_count === 999
  )
}
